import React, { Dispatch, SetStateAction } from 'react'
import HeaderConnector, { ConnectorProps as HeaderProps } from '../../connectors/Header'
import styles from './ArtistInfo.module.scss'
import ActionsConnector, { ConnectorProps as ActionsProps } from '../../connectors/Actions'
import FollowConnector, { ConnectorProps as FollowProps } from 'containers/Follow'
import AuthenticationConnect, {
  ConnectorProps as AuthenticationProps,
} from 'connectors/Authentication'
import useIsMobile from 'hooks/useIsMobile'
import FilterIcon from 'svg/filter-v2.svg'
import FiltersChips from '../FiltersChips/FiltersChips'
import Skeleton from 'components/SA/Skeleton'
import useAvoidLayoutShift from 'hooks/useAvoidLayoutShift'

type ArtistInfoProps = HeaderProps &
  ActionsProps &
  FollowProps &
  AuthenticationProps & {
    isFiltersVisible: boolean
    setIsFiltersVisible: Dispatch<SetStateAction<boolean>>
    onOpenMobileFilter: () => void
  }

const ArtistInfo = (props: ArtistInfoProps) => {
  const { isFiltersVisible, setIsFiltersVisible, onOpenMobileFilter, facetsCount } = props
  const { isSkeletonVisible } = useAvoidLayoutShift()
  const isMobileScreen = useIsMobile()
  const handleToggleFiltersVisibility = () => {
    if (isMobileScreen) {
      onOpenMobileFilter()
    } else {
      setIsFiltersVisible((prevValue) => !prevValue)
    }
  }

  return (
    <div className={styles.artistInfoHeaderWrapper}>
      <div className={styles.filtersSelectedContainer}>
        {isSkeletonVisible ? (
          <Skeleton width='160px' height='40px' />
        ) : (
          <button onClick={handleToggleFiltersVisibility} className={styles.headerFilterButton}>
            <FilterIcon />
            <span>
              {!isFiltersVisible || isMobileScreen ? 'Filters' : 'Hide Filters'}{' '}
              {facetsCount ? ` (${facetsCount})` : ``}
            </span>
          </button>
        )}
        <FiltersChips />
      </div>
    </div>
  )
}

export default HeaderConnector(ActionsConnector(FollowConnector(AuthenticationConnect(ArtistInfo))))
